import { DataGridPro, LicenseInfo, esES } from '@mui/x-data-grid-pro';
import { useEffect, useState } from 'react';
import classes from "../XGrid/XGrid.module.scss";
const LICENSE_KEY = "ac8c44d2650f10c5456f59e7602dc69cTz0xMTE5MzIsRT0xNzc3MDc1MTk5MDAwLFM9cHJvLExNPXN1YnNjcmlwdGlvbixQVj1pbml0aWFsLEtWPTI=";
LicenseInfo.setLicenseKey(LICENSE_KEY);


export default function XGridServer({loading=false, list, setNumberPage, columns, rowsCount, updateList = async () => { },
rowSelect = () => {}, 
setRow = () => {},
onPageChange = () => { },
onPageSizeChange = () => { },
onNumberOfPagesChange = () => { }, pageSize, setPageSize}) {
  const [rowCount, setRowCount] = useState(0);
  const [numberOfPages, setNumberOfPages] = useState(1);
  const [page, setPage] = useState(1);
  const handleProxPage = (newPage) => {
    setPage(newPage.page +1)
    setNumberPage(newPage.page +1)
  }

  useEffect(() => {
    setRowCount(rowsCount)
  }, [rowsCount])
  // useEffect(() => {
  //   let element = document?.getElementsByClassName("css-204u17-MuiDataGrid-main")[0]?.lastChild
  //   element?.setAttribute("style", "display:none;")
  // }, [])
  return (
    <div style={{ width: '100%', height: '100%' }}>
      <DataGridPro
        style={{minHeight: "200px"}}
        rows={list ?? []}
        columns={columns}
        loading={loading}
        count={rowCount ?? list.length}
        pagination
        className={classes.root}
        disableColumnMenu
        onRowClick={(data) => {
          if (data.row.id === rowSelect?.row?.id) {
            setRow({ status: false, row: {} })
            return;
          }
          setRow({ status: true, row: data.row })
        }}
        autoPageSize
        selectionModel={rowSelect?.row?.id || []}
        onPaginationModelChange={(newPage) => {
          setPage(newPage);
          onPageChange(newPage);
          handleProxPage(newPage)
        }}
        onPageSizeChange={(newPageSize) => {
          setPageSize(newPageSize);
          onPageSizeChange(newPageSize);
        }}
        onStateChange={(state) => {
          const newNumberOfPages = state.pagination.pageCount + 1;
          if(pageSize === 0 || pageSize === state?.pagination?.paginationModel?.pageSize){
            onPageSizeChange(state?.pagination?.paginationModel?.pageSize)
          }
          if (newNumberOfPages !== numberOfPages) {
            setNumberOfPages(newNumberOfPages);
            onNumberOfPagesChange(newNumberOfPages);
          }
        }}
        rowHeight={32}
        localeText={{ ...esES.components.MuiDataGrid.defaultProps.localeText, noRowsLabel: "Sin datos" }}
      />
    </div>
  );
}